"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Head_1 = __importDefault(require("./Head"));

var Info_1 = __importDefault(require("./Info"));

var Collapse_1 = require("../Collapse");

var isFunction_1 = __importDefault(require("lodash/isFunction"));

var classnames_1 = __importDefault(require("classnames"));

exports.default = function (_a) {
  var className = _a.className,
      cardClassName = _a.cardClassName,
      boundWitnesses = _a.boundWitnesses;

  var _b = react_1.useState(null),
      active = _b[0],
      setActive = _b[1];

  var toggle = function toggle(i) {
    return function () {
      setActive(active === i ? null : i);
    };
  };

  return react_1.default.createElement("div", {
    className: classnames_1.default('accordion', className)
  }, boundWitnesses.map(function (boundWitness, i, arr) {
    return react_1.default.createElement("div", {
      className: classnames_1.default('card', isFunction_1.default(cardClassName) ? cardClassName(boundWitness, i, arr) : cardClassName),
      key: i
    }, react_1.default.createElement(Head_1.default, {
      onClick: toggle(i),
      boundWitness: boundWitness
    }), react_1.default.createElement(Collapse_1.Collapsible, {
      show: active === i
    }, react_1.default.createElement(Info_1.default, {
      className: 'card-body',
      boundWitness: boundWitness
    })));
  }));
};